import React from 'react';

export const Modal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className=" fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50">
      <div className="bg-[#F0F0F0] dark:bg-[#282828] mx-4 p-5 rounded-lg relative ">
        <button
          onClick={onClose}
          className="absolute top-2 right-2  text-3xl dark:text-[#C7C7C7]"
        >
          &times;
        </button>
        <h2 className=" w-[80%] text-lg text-[#1c1c1c] dark:text-white">Are you sure you want to cnacel uploading this product?</h2>
        <p className='py-3 w-3/4 opacity-80'>Your progress will be lost and you have to start from scratch.</p>
        <div className="flex justify-start space-x-2">
          
          <button
            onClick={onConfirm}
            className="bg-[#E85959] text-white px-4 py-2 rounded-md"
          >
            Confirm
          </button>
          <button
            onClick={onClose}
            className="border-[1.5px] border-[#1c1c1c] dark:text-white dark:border-[#5B5B5B] px-4 py-2 rounded-md"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
